export const apiUrl = function() {
    if (location.hostname === 'localhost') {
        return 'http://localhost:9000/';
    } else {
        return '/';
    }
}();
